import { BaseButtons, BaseCheckbox, BaseForm, BaseGridLayout, BaseScatola, BaseTextInput, useFormContext, BaseContenutoConProgress } from '@lucan/base-ui'
import { DATICONDUCENTE_VERBALE_DECURTAZIONE } from 'configuration/datiConducente'
import FormCaricaFile, { FormCaricaFileProvider, RiassuntoFileCaricato } from 'components/form/FormCaricaFile'
import SezioneForm from 'components/form/SezioneForm'
import MessaggioEvidenziato from 'components/ui/MessaggioEvidenziato'
import Sezione from 'components/ui/Sezione'
import Sottotitolo from 'components/ui/Sottotitolo'
import Testo from 'components/ui/Testo'
import Titoletto from 'components/ui/Titoletto'
import useInfoComando from 'hook/useInfoComando'
import useSchermoStretto from 'hook/useSchermoStretto'
import { CFG_MODALITA_INVIO_DATI_CONDUCENTE, MODALITA_INVIO_DATI_CONDUCENTE, SITUAZIONE_DATI_CONDUCENTE } from '../utilDatiConducente'

const CFG = DATICONDUCENTE_VERBALE_DECURTAZIONE

export default function DecurtazionePuntiConsegnaModulo(props) {
  const {
    val, txt,
    situazione,
    modalitaInvio,
    email,
    setEmail,
    emailDichiarante,
    fileCaricati,
    setFileCaricati,
  } = props

  const { cfgSpiegazione } = CFG_MODALITA_INVIO_DATI_CONDUCENTE[modalitaInvio]

  return (
    <>
      <Sezione titolo={val(CFG.CONSEGNA_MODULO_TITOLO)}>
        <BaseGridLayout vertical>
          <Testo>{txt(cfgSpiegazione)}</Testo>

          <MessaggioEvidenziato error titolo={val(CFG.CONSEGNA_MODULO_AVVISO_PROCEDURA_INCOMPLETA_TITOLO)}>
            {txt(CFG.CONSEGNA_MODULO_AVVISO_PROCEDURA_INCOMPLETA_DESCR)}
          </MessaggioEvidenziato>

          {modalitaInvio === MODALITA_INVIO_DATI_CONDUCENTE.CARICA_ONLINE ? (
            <ModalitaCaricaOnline
              txt={txt}
              situazione={situazione}
              fileCaricati={fileCaricati}
              setFileCaricati={setFileCaricati}
            />
          ) : (
            <ModalitaConsegnaNonOnline
              txt={txt}
              modalita={modalitaInvio}
            />
          )}
        </BaseGridLayout>
      </Sezione>

      {modalitaInvio === MODALITA_INVIO_DATI_CONDUCENTE.CARICA_ONLINE &&
        <Sezione sx={{ mt: 4 }}>
          {email ? (
            <MessaggioEvidenziato info titolo={val(CFG.CONSEGNA_MODULO_AGGIORNAMENTO_PRATICA_AVVISO_EMAIL_SALVATA_TITOLO)}>
              <BaseGridLayout alignCenter>
                <Testo noMargine>{txt(CFG.CONSEGNA_MODULO_AGGIORNAMENTO_PRATICA_AVVISO_EMAIL_SALVATA_DESCR)}</Testo>
                <Testo grassetto noMargine>{email}</Testo>
                <BaseButtons.Modifica
                  testo={val(CFG.CONSEGNA_MODULO_AGGIORNAMENTO_PRATICA_AVVISO_EMAIL_SALVATA_MODIFICA)}
                  size='small'
                  color='secondary'
                  variant='outlined'
                  noMarginY
                  onClick={() => setEmail('')}
                />
              </BaseGridLayout>
            </MessaggioEvidenziato>
          ) : (
            <BaseGridLayout vertical>
              <MessaggioEvidenziato info titolo={val(CFG.CONSEGNA_MODULO_AGGIORNAMENTO_PRATICA_AVVISO_TITOLO)}>
                {txt(CFG.CONSEGNA_MODULO_AGGIORNAMENTO_PRATICA_AVVISO_DESCR)}
              </MessaggioEvidenziato>

              <BaseScatola outlined>
                <FormAggiornamentoPratica
                  val={val} txt={txt}
                  setEmail={setEmail}
                  emailDichiarante={emailDichiarante}
                />
              </BaseScatola>
            </BaseGridLayout>
          )}
        </Sezione>
      }
    </>
  )
}



function ModalitaCaricaOnline(props) {
  const { txt, situazione, fileCaricati, setFileCaricati } = props

  const nonCasoB = situazione !== SITUAZIONE_DATI_CONDUCENTE.CASO_B
  const casoC = situazione === SITUAZIONE_DATI_CONDUCENTE.CASO_C

  return (
    <BaseScatola outlined>
      <FormCaricaFileProvider>
        <SezioneForm
          titolo={txt(CFG.CONSEGNA_MODULO_CARICA_ONLINE_DOCUMENTAZIONE)}
          defaultValues={fileCaricati ?? { modulo: null, patente: null, verbale: null }}
          onSubmit={({ modulo, patente, verbale }) => {
            setFileCaricati({
              ...fileCaricati,
              ...(modulo && { modulo: modulo[0] }),
              ...(patente && { patente: patente[0] }),
              ...(verbale && { verbale: verbale[0] }),
            })
            return { ok: true }
          }}
          Riassunto={({ modulo, patente, verbale }) =>
            <BaseGridLayout vertical>
              <RiassuntoFileCaricato
                nome={txt(CFG.CONSEGNA_MODULO_CARICA_ONLINE_CARICA_MODULO_NOME_MODULO)}
                file={modulo}
              />
              {nonCasoB &&
                <RiassuntoFileCaricato
                  nome={txt(CFG.CONSEGNA_MODULO_CARICA_ONLINE_CARICA_PATENTE_NOME_PATENTE)}
                  file={patente}
                />
              }
              {casoC &&
                <RiassuntoFileCaricato
                  nome={txt(CFG.CONSEGNA_MODULO_CARICA_ONLINE_CARICA_VERBALE_NOME_VERBALE)}
                  file={verbale}
                />
              }
            </BaseGridLayout>
          }
        >
          <BaseGridLayout vertical>
            <ScatolaModalitaConsegna
              txt={txt}
              cfgTitolo={CFG.CONSEGNA_MODULO_CARICA_ONLINE_CARICA_MODULO_TITOLO}
              cfgSottotitolo={CFG.CONSEGNA_MODULO_CARICA_ONLINE_CARICA_MODULO_SOTTOTITOLO}
            >
              <FormCaricaFile
                label={txt(CFG.CONSEGNA_MODULO_CARICA_ONLINE_CARICA_MODULO_NOME_MODULO)}
                name='modulo' fileCaricato={fileCaricati?.modulo}
              />
            </ScatolaModalitaConsegna>

            {nonCasoB &&
              <ScatolaModalitaConsegna
                txt={txt}
                cfgTitolo={CFG.CONSEGNA_MODULO_CARICA_ONLINE_CARICA_PATENTE_TITOLO}
                cfgSottotitolo={CFG.CONSEGNA_MODULO_CARICA_ONLINE_CARICA_PATENTE_SOTTOTITOLO}
              >
                <FormCaricaFile
                  label={txt(CFG.CONSEGNA_MODULO_CARICA_ONLINE_CARICA_PATENTE_NOME_PATENTE)}
                  name='patente' fileCaricato={fileCaricati?.patente}
                />
              </ScatolaModalitaConsegna>
            }

            {casoC &&
              <ScatolaModalitaConsegna
                txt={txt}
                cfgTitolo={CFG.CONSEGNA_MODULO_CARICA_ONLINE_CARICA_VERBALE_TITOLO}
                cfgSottotitolo={CFG.CONSEGNA_MODULO_CARICA_ONLINE_CARICA_VERBALE_SOTTOTITOLO}
              >
                <FormCaricaFile
                  label={txt(CFG.CONSEGNA_MODULO_CARICA_ONLINE_CARICA_VERBALE_NOME_VERBALE)}
                  name='verbale' fileCaricato={fileCaricati?.verbale}
                />
              </ScatolaModalitaConsegna>
            }
          </BaseGridLayout>
        </SezioneForm>
      </FormCaricaFileProvider>
    </BaseScatola>
  )
}



export function ModalitaConsegnaNonOnline(props) {
  const { txt, modalita } = props

  const {
    infoComando,
    ScatolaMessaggiInfoComando,
    inAttesaInfoComando,
  } = useInfoComando()

  return (
    <>
      {ScatolaMessaggiInfoComando}

      <BaseContenutoConProgress inAttesa={inAttesaInfoComando}>
        {infoComando &&
          (function () {
            const { pec, indirizzo, orario } = infoComando

            switch (modalita) {
              case MODALITA_INVIO_DATI_CONDUCENTE.PEC:
                return (
                  <ScatolaModalitaConsegna
                    txt={txt}
                    cfgTitolo={CFG.CONSEGNA_MODULO_PEC_COME_FARE_TITOLO}
                    cfgSottotitolo={CFG.CONSEGNA_MODULO_PEC_COME_FARE_SOTTOTITOLO}
                  >
                    <b>{pec}</b>
                  </ScatolaModalitaConsegna>
                )

              case MODALITA_INVIO_DATI_CONDUCENTE.RACCOMANDATA:
                return (
                  <ScatolaModalitaConsegna
                    txt={txt}
                    cfgTitolo={CFG.CONSEGNA_MODULO_RACCOMANDATA_COME_FARE_TITOLO}
                    cfgSottotitolo={CFG.CONSEGNA_MODULO_RACCOMANDATA_COME_FARE_SOTTOTITOLO}
                  >
                    <b>{indirizzo}</b>
                  </ScatolaModalitaConsegna>
                )

              case MODALITA_INVIO_DATI_CONDUCENTE.A_MANO:
                return (
                  <ScatolaModalitaConsegna
                    txt={txt}
                    cfgTitolo={CFG.CONSEGNA_MODULO_A_MANO_COME_FARE_TITOLO}
                    cfgSottotitolo={CFG.CONSEGNA_MODULO_A_MANO_COME_FARE_SOTTOTITOLO}
                  >
                    <Sottotitolo>
                      {txt(CFG.CONSEGNA_MODULO_A_MANO_COME_FARE_APERTURA_UFFICI)}: <b>{orario}</b>
                    </Sottotitolo>
                    <Sottotitolo>
                      {txt(CFG.CONSEGNA_MODULO_A_MANO_COME_FARE_INDIRIZZO)}: <b>{indirizzo}</b>
                    </Sottotitolo>
                  </ScatolaModalitaConsegna>
                )

              default: return null
            }
          })()
        }
      </BaseContenutoConProgress>
    </>
  )
}



function ScatolaModalitaConsegna(props) {
  const { txt, cfgTitolo, cfgSottotitolo, children } = props

  return (
    <BaseScatola outlined>
      <Titoletto variant='h6'>{txt(cfgTitolo)}</Titoletto>
      <Sottotitolo>{txt(cfgSottotitolo)}</Sottotitolo>
      {children}
    </BaseScatola>
  )
}



function FormAggiornamentoPratica(props) {
  const { val, txt, setEmail, emailDichiarante } = props

  const schermoStretto = useSchermoStretto()

  return (
    <BaseForm
      defaultValues={{
        email: emailDichiarante || '',
        ripetiEmail: emailDichiarante || '',
        accettoPrivacy: false,
        accettoTermini: false,
      }}
      onSubmit={({ email }) => setEmail(email)}
      larghezzaInputs={schermoStretto ? 'fullWidth' : 20}
    >
      <BaseGridLayout vertical>
        <BaseGridLayout {...(schermoStretto && { propsGridItem: { sx: { width: '100%' } } })}>
          <BaseTextInput
            label={txt(CFG.CONSEGNA_MODULO_AGGIORNAMENTO_PRATICA_EMAIL)}
            name='email'
            required
          />
          <CampoRipetiEmail
            label={txt(CFG.CONSEGNA_MODULO_AGGIORNAMENTO_PRATICA_RIPETI_EMAIL)}
            name='ripetiEmail'
            required
            messaggioErroreEmailDiverse={val(CFG.CONSEGNA_MODULO_AGGIORNAMENTO_PRATICA_EMAIL_DIVERSE)}
          />
        </BaseGridLayout>

        <BaseCheckbox
          label={
            <>
              <Testo noMargine grassetto>{txt(CFG.CONSEGNA_MODULO_AGGIORNAMENTO_PRATICA_ACCETTO_PRIVACY)}</Testo>
              {txt(CFG.CONSEGNA_MODULO_AGGIORNAMENTO_PRATICA_ACCETTO_PRIVACY_DESCR)}
            </>
          }
          name='accettoPrivacy'
          required
        />

        <BaseCheckbox
          label={
            <>
              <Testo noMargine grassetto>{txt(CFG.CONSEGNA_MODULO_AGGIORNAMENTO_PRATICA_ACCETTO_TERMINI)}</Testo>
              {txt(CFG.CONSEGNA_MODULO_AGGIORNAMENTO_PRATICA_ACCETTO_TERMINI_DESCR)}
            </>
          }
          name='accettoTermini'
          required
        />

        <BaseButtons.Salva
          testo={val(CFG.CONSEGNA_MODULO_AGGIORNAMENTO_PRATICA_SALVA_EMAIL)}
          color='info'
          noMarginY
        />
      </BaseGridLayout>
    </BaseForm>
  )
}



function CampoRipetiEmail(props) {
  const { messaggioErroreEmailDiverse, ...restProps } = props

  const { watch } = useFormContext()
  const email = watch('email')

  return (
    <BaseTextInput
      {...restProps}
      validazione={{
        validate: {
          emailDiverse: ripetiEmail => ripetiEmail === email
        }
      }}
      messaggiErrore={{
        emailDiverse: messaggioErroreEmailDiverse
      }}
    />
  )
}